import APIClient from './index';
import _ from 'lodash';

export const getManualOrderAdjustments = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('AffiliateCommissions/manual_adjustments', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createManualOrderAdjustment = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('AffiliateCommissions/manual_adjustments', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const previewManualOrderAdjustmentsCsv = csv => {
  return new Promise((resolve, reject) => {
    APIClient.post('AffiliateCommissions/manual_adjustments/bulk/preview', { csv })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createManualOrderAdjustmentsBulk = csv => {
  return new Promise((resolve, reject) => {
    APIClient.post('AffiliateCommissions/manual_adjustments/bulk', { csv })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const previewCreatorCommissionVoid = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('AffiliateCommissions/void_creator_commissions/preview', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const voidCreatorCommissions = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('AffiliateCommissions/void_creator_commissions', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
